import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import "./findbook.css";
import Button from "react-bootstrap/Button";
import alertify from "alertifyjs";

const Findbook = () => {
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [searchBarcode, setSearchBarcode] = useState("");
  const [submittedBarcode, setSubmittedBarcode] = useState("");
  const [displayedDorderid, setDisplayedDorderid] = useState("");

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getship`).then((response) => {
      const reversedData = response.data.reverse();
      setData(reversedData);
    });

    Axios.get(`${INVENTORY_API_BASE_URL}/getApproveDPO`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setDataa(reversedData);
      }
    );
  }, []);

  const handleSearch = () => {
    if (searchBarcode.trim() === "") {
      alertify("Please enter a barcode before submitting.");
    }
    let found = false;
    let orderNum = null;

    data.forEach((item) => {
      if (item.barcodeData) {
        item.barcodeData.forEach((barcode) => {
          if (
            barcode.scannedData?.includes(searchBarcode)
          ) {
            found = true;
            orderNum = barcode.OrderNum;
          }
        });
      }
    });

    setSubmittedBarcode(searchBarcode);
    setSearchBarcode("");

    if (found) {
      const matchingOrder = dataa.find(
        (order) => order.shipmentid === orderNum
      );

      if (matchingOrder) {
        setDisplayedDorderid(matchingOrder.Dorderid);
      } else {
        setDisplayedDorderid("");
      }
    } else {
      setDisplayedDorderid("");
    }
  };

  return (
    <div className="piracybarcode">
      <h5 className="findbook">
        <h3 className="findbookheading">Enter Barcode to search distributor</h3>
      </h5>
      <br />

      <h5 className="findbooksearch">
        <input
          type="text"
          placeholder="Search Barcode"
          value={searchBarcode}
          onChange={(e) => setSearchBarcode(e.target.value)}
        />
        <div className="findbooksearch">
          <br />
          <br />
          <Button onClick={handleSearch}>Submit</Button>
        </div>
      </h5>

      {displayedDorderid && (
        <div>
          <p id="distri">Distributor Name: {displayedDorderid}</p>
          <p style={{ fontSize: "1.5rem" }}>
            Searched Barcode: {submittedBarcode}
          </p>
        </div>
      )}
    </div>
  );
};

export default Findbook;
